import { useClient } from '@composables/use-clients';
import { DeleteRequestArgsType } from '@api/v1/types';
import { useTenantStore } from '@stores/tenant-store';
import { urls } from '@api/urls';
import { withTryCatch } from '@api/v1/error-handlers';

export type DeleteTenantUserArgsType = {
  tenantUserId: number;
} & DeleteRequestArgsType;

export const apiFetchTenantUsers = async ({
  domain = useTenantStore().domain,
  tenantUserId = null,
  query = {},
  errorConfig = {},
  callbacks = {},
} = {}) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.get({
      url: urls.v1.tenantUsers({ domain, tenantUserId }),
      query,
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};

export const apiDeleteTenantUser = async ({
  domain = useTenantStore().domain,
  tenantUserId,
  errorConfig = {},
  callbacks = {},
}: DeleteTenantUserArgsType) => {
  const impl = async () => {
    const { client } = useClient('auth');
    const res = await client.delete({
      url: urls.v1.tenantUsers({ domain, tenantUserId }),
    });
    return res;
  };

  return withTryCatch({ impl, errorConfig, callbacks });
};
